import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Tablet.svg",
  "use": "Tablet.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Tablet.svg\"><path d=\"M15.01,51.0208v-38a5,5,0,0,1,5-5h24a5,5,0,0,1,5,5v38a5,5,0,0,1-5,5h-24A5,5,0,0,1,15.01,51.0208Zm30-3v-32a1,1,0,0,0-1-1h-24a1,1,0,0,0-1,1v32a1,1,0,0,0,1,1h24A1,1,0,0,0,45.01,48.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol